import { useApi } from "../../../swr/useApi";
import { documentsService, adminProductRequestsService } from "../../api_client";
import type { UsersDocumentsResponseDto, ProductRequestQueryDto } from "../../../api";
import { DocumentsQueryDtoStatusEnum, ProductRequestQueryDtoRequestStatusEnum } from "../../../api";

export function useAdminDashboardStats() {
  const { data: pendingDocs } = useApi<UsersDocumentsResponseDto>(
    "admin-dashboard-stats-pending-docs",
    () => documentsService.getDocumentsGroupedByUser({ status: DocumentsQueryDtoStatusEnum.Pending, page: 1, pageSize: 1 }),
  );

  const { data: pendingRequests } = useApi(
    "admin-dashboard-stats-pending-requests",
    () => adminProductRequestsService.adminGetAllProductRequests(
      { requestStatus: ProductRequestQueryDtoRequestStatusEnum.Pending, page: 1, pageSize: 1 } as ProductRequestQueryDto,
    ),
  );

  return {
    pendingActions:
      (pendingDocs?.meta?.totalCount ?? 0) +
      ((pendingRequests as { meta?: { totalCount?: number } } | undefined)?.meta?.totalCount ?? 0),
  };
}
